// extracted by mini-css-extract-plugin
export default {"ring":"Spinner_ring__4OGEg","ring__part":"Spinner_ring__part__NyOJA"};